import React, { Fragment } from 'react';
import { formatDate } from '../../../../utils/helpers';
import { FlexDiv } from '../../../design-system/containers';
import DetailsField from './email-details-field';
import DetailsRow from './email-details-row';
import { observer } from "mobx-react";
function patchEmail(email) {
  if ( email && email.indexOf("|") > -1 ){
    // return part before |
    return email.split("|")[0];
  }
  return email;
}

const Table = ({ t, fromName, fromEmail, userName, userEmail, toExtraEmailTransformed, subject }) => (
  <table>
    <tbody>
    <DetailsRow>
      <DetailsField isLabel>{t('from')}</DetailsField>
      <DetailsField>
        <b>{fromName}</b> {'<'}
        {fromEmail}
        {'>'}
      </DetailsField>
    </DetailsRow>
    <DetailsRow>
      <DetailsField isLabel>{t('to')}</DetailsField>
      <DetailsField>
        {userName} {'<'}
        {patchEmail(userEmail)}
        {'>'}{' '}
        {toExtraEmailTransformed && (
          <Fragment>
            <br />
            {toExtraEmailTransformed}
          </Fragment>
        )}
      </DetailsField>
    </DetailsRow>
    <DetailsRow>
      <DetailsField isLabel>{t('date')}</DetailsField>
      <DetailsField>
        {formatDate(new Date())}, 10:38:12
      </DetailsField>
    </DetailsRow>
    <DetailsRow>
      <DetailsField isLabel>{t('subject')}</DetailsField>
      <DetailsField>{subject}</DetailsField>
    </DetailsRow>
    </tbody>
  </table>
)

const Details = ({
    userEmail,
    userName,
    fromName,
    fromEmail,
    subject,
    toExtraEmail,
    node,
    open,
    t,
}) => {
    const toExtraEmailTransformed =
        toExtraEmail &&
        toExtraEmail.split(',').map((email, i) => (
            <span key={i}>
                {email}
                <br />
            </span>
        ));


    return (
        <div ref={node} style={{ display: open ? 'block' : 'none' }}>
            <FlexDiv borderRadius={8} padding={8} gap={8} border mobileOnly>
                <Table {...({ t, fromName, fromEmail, userName, userEmail, toExtraEmailTransformed, subject })  } />
            </FlexDiv>
            <FlexDiv
                padding={16}
                gap={16}
                border
                desktopOnly
                positionAbsolute
                zIndex={1}
                backgroundColor="white"
                left={96}
                top={64}
            >
                <Table {...({ t, fromName, fromEmail, userName, userEmail, toExtraEmailTransformed, subject })  } />
            </FlexDiv>
        </div>
    );
};

export default observer(Details);
